import { Card, Col, Row, Statistic, Tabs } from "antd";
import { motion } from "framer-motion";
import ajaxService from "../../services/ajax-service";
import { useEffect, useState } from "react";
import { COURT_USER } from "../../constants";

const CourtDashboard = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [data, setData] = useState({
        'new_bookings': 0,
        'total_payment_to_receive': 0,
    });

    const onChange = (key) => {
        console.log(key);
    };

    const initialize = async () => {
        const response = await ajaxService.get('/court-dashboard');
        if (response.success) {
            setData(response.data);
        }
    }

    useEffect(() => {
        if (localStorage.getItem('role') === COURT_USER) {
            initialize()
        }
    }, []);

    // Listen for sidebar collapse state
    useEffect(() => {
        const handleSidebarCollapse = (event) => {
            setSidebarCollapsed(event.detail.collapsed);
        };

        window.addEventListener('sidebarCollapse', handleSidebarCollapse);
        return () => window.removeEventListener('sidebarCollapse', handleSidebarCollapse);
    }, []);

    const statisticsData = [
        { title: 'New Bookings', value: data.new_bookings },
        { title: 'Total Payment To Recieve', value: '$'+data.total_payment_to_receive },
    ]

    const items = [
        // {
        //     key: '1',
        //     label: 'Overview',
        //     children: 'Content of Overview',
        // },
        {
            key: '2',
            label: 'Statistics',
            children: statistics(),
        }
    ];

    function statistics() {
        return (
            <div className="stats-grid">
                {statisticsData.map(({ title, value }, index) => (
                    <motion.div
                        key={title}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                    >
                        <div className="stats-card">
                            <div className="stats-value">{value}</div>
                            <div className="stats-label">{title}</div>
                        </div>
                    </motion.div>
                ))}
            </div>
        )
    }


    return (
        <div className={`page-container ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            <div className="module-header">
                <h1 className="module-title">Court Dashboard</h1>
                <p className="module-subtitle">Overview of your court bookings and payments</p>
            </div>
            <Tabs 
                defaultActiveKey="2" 
                items={items} 
                onChange={onChange}
                style={{
                    background: 'var(--dark-bg-card)',
                    padding: 'var(--spacing-lg)',
                    borderRadius: 'var(--radius-lg)',
                    border: '1px solid rgba(254, 2, 125, 0.2)',
                }}
            />
        </div>
    )
}

export default CourtDashboard